import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorksApi from '@/services/apiServiceModules/worksApi'
const worksApi = new WorksApi()

export default class WorksDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS, worksApi, {
			useCache: true,
		})
	}
}
